<template>
  <b-dropdown :disabled="disabled">
    <template slot="button-content">
      <font-awesome-icon icon="plus" />
      Toevoegen stap
    </template>
    <b-dropdown-group header="Voortraject">
      <b-dropdown-item
        v-for="option in voortraject"
        :key="option"
        @click="() => $emit('action',{ value: 'Standaard', label: option })"
      >
        {{ option }}
      </b-dropdown-item>
    </b-dropdown-group>
    
    <b-dropdown-group header="Begeleiding">
      <b-dropdown-item
        v-for="option in uitvoeringtaken" 
        :key="option"
        @click="() => $emit('action',{ value: 'Standaard', label: option })"
      >
        {{ option }}
      </b-dropdown-item>
    </b-dropdown-group>

    <b-dropdown-group header="Speciale stappen">
      <b-dropdown-item
        v-for="option in wizards"
        :key="option"
        @click="() => $emit('action',{ value: option, label: option })"
      >
        {{ option }}
      </b-dropdown-item>
    </b-dropdown-group>
  </b-dropdown>
</template>
<script>
import { trajectenMixin } from "@/mixins/trajectenMixin";
 export default {
     name: 'TrajectMenu',
     components: {},
     mixins: [trajectenMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
     data() {
         return  {
         }
     },
     computed: {},
     watch: {},
     mounted () {
         
     },
     methods: {},
           
 }
 </script>